function intSignConvert(num) {
  return num - num * 2;
}

export default intSignConvert;
